import src from "IMAGE";
export default { src, width: 31, height: 32, blurWidth: 0, blurHeight: 0};
